var render, staticRenderFns
import script from "./NavigationList.vue?vue&type=script&lang=ts&"
export * from "./NavigationList.vue?vue&type=script&lang=ts&"
import style0 from "./NavigationList.vue?vue&type=style&index=0&id=370d9dfa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports